export default __webpack_public_path__ + "static/media/delet.02272d41.svg";